// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/Assets/SignInFaceRecognition/mainBackgroundImage.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/Assets/SignInFaceRecognition/containerbackgroundImage.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignInFaceRecognition {
    display: flex;
    align-items: center;
    justify-content: center;
    /* height: 100%;
    width: 100%; */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    color: #fff;
    width: 100vw;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 100vh;
    color: white;
    overflow: hidden;

}
.faceRecognitionContent{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5vh!important;
}

.signInFaceRecognitionContainer {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 97vh;
    width: 98.8vw;
    border-radius: 10px;
    position: relative;
    padding-top: 5vh;
    /* margin-bottom: 1vh; */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.faceRecognitionHeader {
    position: absolute;
    top: 10%;
    left: 11%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
}

.faceRecognitionHeaderLogo {
    width: 17vw;
}`, "",{"version":3,"sources":["webpack://./src/Components/SignInFlow/SignInFaceRecognition/SignInFaceRecognition.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;kBACc;IACd,yDAAgG;IAChG,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,YAAY;IACZ,gBAAgB;;AAEpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,yDAAqG;IACrG,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf","sourcesContent":[".SignInFaceRecognition {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    /* height: 100%;\n    width: 100%; */\n    background-image: url(\"../../../../public/Assets/SignInFaceRecognition/mainBackgroundImage.svg\");\n    color: #fff;\n    width: 100vw;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n    height: 100vh;\n    color: white;\n    overflow: hidden;\n\n}\n.faceRecognitionContent{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5vh!important;\n}\n\n.signInFaceRecognitionContainer {\n    background-image: url(\"../../../../public/Assets/SignInFaceRecognition/containerbackgroundImage.svg\");\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    height: 97vh;\n    width: 98.8vw;\n    border-radius: 10px;\n    position: relative;\n    padding-top: 5vh;\n    /* margin-bottom: 1vh; */\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.faceRecognitionHeader {\n    position: absolute;\n    top: 10%;\n    left: 11%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n.faceRecognitionHeaderLogo {\n    width: 17vw;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
